import { render, staticRenderFns } from "./BasketContent.vue?vue&type=template&id=dd90956e&scoped=true&"
import script from "./BasketContent.vue?vue&type=script&lang=js&"
export * from "./BasketContent.vue?vue&type=script&lang=js&"
import style0 from "./BasketContent.vue?vue&type=style&index=0&id=dd90956e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd90956e",
  null
  
)

export default component.exports